import { searchGenericComponent, SearchSettingDTOModal } from './../../components/search/searchGeneric.component';
import { ActionParameterDefinitionDTO } from './../../api/plyca-dtos-v2';
import { Component, AfterContentInit, ElementRef, OnInit, OnDestroy, ViewChild, ComponentFactoryResolver } from '@angular/core';
import {
  ActionDTO, getSimpleIdentifierFromString, SearchResultDTO
} from '../../api/plyca-dtos';
import { ServiceLocator } from '../../ServiceLocator';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { generateRandomIdentifier, UIService } from '../../ui.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { FieldConfig } from '../../api/contract-notice-dto';
import { finalize } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ActionResultDTO } from '../../api/plyca-dtos-v2';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { ActionService } from '../../actions/action.service';
import { PlycaDataService } from '../../../services/plyca.service';
import { FormConfig } from '../../components/forms/form.objects';
import { UserService } from '../../user.service';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import * as lodash from 'lodash';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { ConfirmationService } from 'primeng-lts/api';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { PropertyService } from '../../properties/property.service';


@Component({
  selector: 'change-situation',
  templateUrl: 'change.situation.template.html',
  providers: [DialogService, UIService]
})
export class CHANGE_STATUS_SITUATION extends BaseComponent implements AfterContentInit, OnInit, OnDestroy {

  public action: ActionDTO;
  public paramsDef: ActionParameterDefinitionDTO[];
  public actionService: ActionService;
  private confirmationService: ConfirmationService;

  public windowHash: string;
  public loaded = false;
  result: any;
  dto: any;

  private uiService: UIService;
  running: boolean;
  private translate: TranslateService;
  configuration: any;



  public model: any;
  public model1: any;
  usuSoporte = false;
  usuPermitido = false;
  userService: UserService;
  isDeveloperMode = false;
  tab = '';


  @ViewChild('formPlycaRef') formPlycaRef: formPlycaComponent;
  @ViewChild('formPlycaRef') formPlycaRef1: formPlycaComponent;
  formConfig: FormConfig;
  formConfig1: FormConfig;


  constructor(

    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    protected componentFactoryResolver: ComponentFactoryResolver,
    public waitService: WaitLoadingService,
    private elem: ElementRef,
    private headerActionsService: HeaderActionsService,
    public plycaService: PlycaDataService,
    public propertyService: PropertyService,
    public dialogService: DialogService,
    private plycaErrorHandler: PlycaErrorHandler
  ) {
    super();
    this.uiService = ServiceLocator.injector.get(UIService);
    this.userService = ServiceLocator.injector.get(UserService);
    // this.actionService = ServiceLocator.injector.get(ActionService);


    this.translate = ServiceLocator.injector.get(TranslateService);
    this.confirmationService = ServiceLocator.injector.get(ConfirmationService);

    this.waitService.startWaiting();
    this.action = dialogConfig['action'];
    this.model = dialogConfig['dto'];
    this.paramsDef = dialogConfig['paramsDef'];
    this.usuSoporte = this.userService.hasRoles('50');

    this.subscribe(this.propertyService.getProperty('FraSelExpediente.perfilesVerBotonSituacion', '5'), (value: string) => {
      this.usuPermitido = this.userService.hasRoles(value);
    });

    this.dtoTomodel();
    this.model1 = lodash.cloneDeep(this.model);
    this.model1.division = {};
    this.tab = 'SITUATION';

    /* this.model1.division.identifier = {};
     this.model1.division.identifier = 0;
     this.model1.division.description = 'Expediente - División 0';
 */


  }
  dtoTomodel() {
    let tmp = this.getSituationIdentifier(this.model.status.situation);
    this.model.situationSelected = {};
    this.model.situationSelected = tmp;
    this.model.usuSoporte = this.usuSoporte;
    this.model.usuPermitido = this.usuPermitido;
    this.model.supportusers = [];

    this.model.phaseVisible = true;

    this.model.allSituations = [
      {
        'label': this.translate.instant('DossierLinks.situation.type.0'),
        'value': '0'
      },
      {
        'label': this.translate.instant('DossierLinks.situation.type.1'),
        'value': '1'
      },
      {
        'label': this.translate.instant('DossierLinks.situation.type.2'),
        'value': '2'
      },
      {
        'label': this.translate.instant('DossierLinks.situation.type.3'),
        'value': '3'
      },
      {
        'label': this.translate.instant('DossierLinks.situation.type.4'),
        'value': '4'
      }

    ];

    // Se consultan los usuarios que tienen acceso de soporte al expediente
    let params = new Map<string, string>();
    params.set('PROPUESTAID', this.normalizaDossierId(this.model.identifier));
    this.subscribe(
      this.plycaService.getSearchSetting('USUARIOS_EXPTE_SOPORTE'), ((def: any) => {
        this.subscribe(this.plycaService
          .getResultSearchSetting(
            def.links[0].href + '/values?',
            params
          ).pipe(finalize(() => {
            if ((tmp === '5')) {
              this.model.canModifySituation = this.isSupportUser();
            } else {
              this.model.canModifySituation = this.usuSoporte || this.usuPermitido;
            }
            if (this.model.usuSoporte || this.isSupportUser()) {
              this.model.allSituations.push({
                'label': this.translate.instant('DossierLinks.situation.type.5'),
                'value': '5'
              });
            }

            this.subscribe(this.createFormConfig(),
              (form: FormConfig) => {
                this.subscribe(this.configureFormConfig(form),
                  (form: FormConfig) => {

                    this.formConfig = form;



                    this.subscribe(this.createFormConfig1(),
                      (form1: FormConfig) => {
                        this.subscribe(this.configureFormConfig1(form1),
                          (form1: FormConfig) => {

                            this.formConfig1 = form1;

                            this.loaded = true;

                            this.waitService.cancelWaiting();


                          })

                      })


                    this.waitService.cancelWaiting();
                    this.loaded = true;




                  })

              })

          }))
          , ((result: SearchResultDTO) => {
            console.log(result);
            let users = [];
            if (result && result.content) {
              result.content.map((data) => {
                let user = {
                  identifier: data.singleValue
                }
                users.push(user);
              }

              )
            }
            this.model.supportusers = users;


          }))

      }))


  }
  ngOnDestroy() {
    this.uiService = null;
    this.dialogConfig = null;
    this.dialogService = null;
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  ngOnInit() {

    this.windowHash = generateRandomIdentifier();
    this.waitService.startWaiting();
    this.initHeaderActions();




  }

  ngAfterContentInit() {
    /*  this.subscribe(
        forkJoin(
          this.formPlycaRef.getCompleted(),
          this.formPlycaRef1.getCompleted()),

        () => {

          this.waitService.cancelWaiting();
        }
      );*/

  }


  initHeaderInfo() {

  }

  initHeaderActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);

    this.subscribe(this.headerActionsService.addWindowAction(
      this.translate.instant('General.cancel'), 'fas fa-times', 'btn-secondary', true, this.windowHash),
      success => {
        this.close();
      });
    if (this.usuSoporte || this.usuPermitido) {

      this.subscribe(this.headerActionsService.addWindowAction(
        this.translate.instant('Actions.execute'), 'fas fa-play', 'btn-primary', true, this.windowHash),
        success => {
          this.execute(this.tab);
        });

    }
  }

  close() {
    this.ref.close();
  }


  public execute(tab: string): Observable<any> | void {

    let message = this.translate.instant('DossierLinks.situation.execute.confirm');
    if (this.showDangerAlert() && (tab === 'SITUATION')) {
      message = this.translate.instant('DossierLinks.situation.execute.confirm1') + message;
    }

    this.confirmationService.confirm({
      message: message,
      accept: () => {
        this.waitService.startWaiting();


        let parameters = this.parameters2string(tab);
        console.log(
          'Ejecutando acción',
          this.action.identifier,
          'con los siguiente parametros',
          parameters
        );

        this.subscribe(

          this.plycaService
            .runActionLink(
              this.action, parameters
            )
            .pipe(finalize(() => {
              this.running = false;
              this.waitService.cancelWaiting();

            })),
          (result: ActionResultDTO) => {
            console.log('Acción ejecutada: ', result);
            if (result.identifier === 'OK') {
              if (result.objectResult) {
                let msgObj = result.objectResult ? '\n' + JSON.stringify(result.objectResult) : '';
                this.uiService.showMessage(msgObj, 'Info', 'errorStyle');
              } else {
                this.uiService.showSuccess(this.translate.instant('Actions.exec.ok')
                  ,
                  this.translate.instant('General.info'),
                  'success'
                );
                //this.uiService.showMessage('La acción se ha ejecutado correctamente', 'Ok', 'successStyle');
                this.close();
              }
            } else {
              let message = this.translate.instant('General.errorMessage');
              if (result.description) {
                message = result.description;
              }
              this.uiService.showMessage(message, 'Error', 'errorStyle');

            }

          },
          err => {
            // let errMsg = JSON.stringify(err);
            // if (err.message) {
            //   errMsg = err.message;
            // }
            // this.uiService.showMessage(errMsg, this.translate.instant('Actions.exec.error'));
            this.plycaErrorHandler.showServerError(err);

          }
        );
      }
    });

  }



  private parameters2string(tab: string): string {

    if (tab === 'SITUATION') {
      let url =
        '' +
        `${encodeURIComponent('SITUATION')}=${encodeURIComponent(getSimpleIdentifierFromString(this.model.situationSelected))}`
        + '&'
        + `${encodeURIComponent('TARGET')}=${encodeURIComponent(this.model.identifier)}`;
      if (this.model.supportusers) {
        let value = '';
        this.model.supportusers.map(element => {
          value = value + element.identifier + ';';
        });
        url = url + '&'
          + `${encodeURIComponent('userids')}=${encodeURIComponent(value)}`;
      }


      return url

    } else {

      let url =
        `${encodeURIComponent('PHASE')}=${encodeURIComponent(getSimpleIdentifierFromString(this.model1.phase.identifier))}`
        + '&'
        + `${encodeURIComponent('TARGET')}=${encodeURIComponent(this.model1.identifier)}`

      if (this.model1.division.identifier)
        url = url + '&' + `${encodeURIComponent('DIVISION')}=${encodeURIComponent(getSimpleIdentifierFromString(this.model1.division.identifier))}`
      if (this.model1.status && this.model1.procurementProjectStatus.state && this.model1.procurementProjectStatus.state.identifier) {
        url = url + '&'
          + `${encodeURIComponent('STATUS')}=${encodeURIComponent(getSimpleIdentifierFromString(this.model1.procurementProjectStatus.state.identifier))}`

          ;
      }
      return url;
    }
  }







  openUserSelector() {

    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'PERFIL.PERID';
    param1.value = '50';

    parametersURL.push(param1);

    let contextSearch = new SearchSettingDTOModal('UsuariosPorPerfil', true, parametersURL);
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { 'max-height': '80%' }
    };
    config['context'] = contextSearch;



    let ref = this.dialogService.open(searchGenericComponent, config);
    return ref.onClose;
  }

  showDangerAlert() {
    return this.model.situationSelected
      && (
        getSimpleIdentifierFromString(this.model.situationSelected) === '3'
        || getSimpleIdentifierFromString(this.model.situationSelected) === '4'
      );
  }


  showWarningAlert() {
    return this.model.situationSelected
      && (
        getSimpleIdentifierFromString(this.model.situationSelected) === '1'
        || getSimpleIdentifierFromString(this.model.situationSelected) === '2');
  }
  showInfoAlert() {
    return this.model.situationSelected
      && (
        getSimpleIdentifierFromString(this.model.situationSelected) === '0'
        || getSimpleIdentifierFromString(this.model.situationSelected) === '5');
  }


  getSituationIdentifier(description: string): string {

    let identifier = '0';
    switch (description) {
      case 'Normal': {
        identifier = '0';
        break;
      }
      case 'Appealed': {
        identifier = '1';
        break;
      }
      case 'Discrepancy': {
        identifier = '2';
        break;
      }
      case 'Cancelled': {
        identifier = '3';
        break;
      }
      case 'Extinguished': {
        identifier = '4';
        break;
      }
      case 'Support': {
        identifier = '5';
        break;
      }
      default: {
        identifier = '0';
        break;
      }
    }

    return identifier;

  }


  // FormPlyca

  private createFormConfig(): Observable<FormConfig> {
    return of(new FormConfig(undefined,
      'CHANGE_STATUS_SITUATION.json',
      this.model
    ));
  }

  private createFormConfig1(): Observable<FormConfig> {
    return of(new FormConfig(undefined,
      'CHANGE_STATUS_PHASE.json',
      this.model1
    ));
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = false;
    formConfig.isModalWindow = false;
    formConfig.functions.push({
      identifier: 'openUserSelector',
      fn: this.openUserSelector
    });
    return of(formConfig);
  }

  configureFormConfig1(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = false;
    formConfig.isModalWindow = false;

    formConfig.functions.push({
      identifier: 'isDivision0',
      fn: this.isDivision0.bind(this)
    });
    return of(formConfig);
  }


  public isDivision0() {
    return !this.model1.division.identifier || getSimpleIdentifierFromString(this.model1.division.identifier) == '0';


  }
  public isSupportUser() {

    let usuid = this.userService.getUserId();

    return this.model.supportusers.find(o => o.identifier === usuid);


  }

  private normalizaDossierId(dossierId: string): string {
    return dossierId.substring(0, 4) + '/' + dossierId.substring(4);
  }

  getBuscadorDivisionTree(): FieldConfig {
    let config = new FieldConfig();
    config.type = 'DIVISION';
    config.jsonField = 'division';
    config.description = 'Division en la que se modificará la fase';
    config.idBuscador = this.model1.identifier;
    config.fieldStyle = 'col-sm-12';
    return config;
  }

  selectDivision() {

  }
  selectTab(event) {
    if (event.index == 1) {
      this.tab = 'PHASE';

    } else {
      this.tab = 'SITUATION';
    }
  }

}
